import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const getDashboardModulesData = (payload: any) => {
    return ApiService[APIConfig.GET_DASHBOARD_MODULES_DATA.METHOD](APIConfig.GET_DASHBOARD_MODULES_DATA.URL, payload);
}

const DashboardService = {
    getDashboardModulesData
}

export default DashboardService;